// extracted by mini-css-extract-plugin
export default {"title":"ProxyTeamsComponent_title__27Riv","card_container":"ProxyTeamsComponent_card_container__fSa2U","info":"ProxyTeamsComponent_info__rzwNm"};